import API from "../api/api";

export const getClientList = async () => {
    try {
        const response = await API.post("/clientSection/list", {
            sEcho: 1,
            iDisplayStart: 0,
            iDisplayLength: 10, // Reduced from 100 to avoid server error
            sSearch: "",
            iSortCol_0: 0,
            sSortDir_0: "asc",
            aaSorting: [[0, "asc"]],
            bRegex: false,
            bRegex_0: false,
            bSearchable_0: true,
            bSortable_0: true,
            mDataProp_0: 0
        });
        console.log("Clients API Response:", response.data);
        return response.data.data || [];
    } catch (error) {
        console.error("Error fetching client data:", error);
        throw error;
    }
};
